"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class UnitMixModel extends _1.BaseModel {
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            monthlyRent: 'McLabs2__Monthly_Rent__c',
            monthlyRentHigh: 'McLabs2__Monthly_Rent_High__c',
            numUnits: 'McLabs2__Number_of_Units__c',
            propertyId: 'McLabs2__Property__c',
            unitSf: 'McLabs2__Unit_SF__c',
            unitSfHigh: 'McLabs2__Unit_SF_High__c',
            unitType: 'McLabs2__Unit_Type__c'
        };
    }
    transformFromSalesforce(sfUnitMix) {
        super.transformFromSalesforce(sfUnitMix);
        this.monthlyRentPerSf = sfUnitMix.McLabs2__Monthly_Rent_SF__c; // formula field
    }
}
UnitMixModel.UNIT_TYPE = {
    BACHELOR: 'Bachelor',
    BED_1_BATH_1: '1Bdr/1Bath',
    BED_2_BATH_1: '2Bdr/1Bath',
    BED_2_BATH_2: '2Bdr/2Bath',
    BED_3_BATH_1: '3Bdr/1Bath',
    BED_3_BATH_2: '3Bdr/2Bath',
    BED_3_BATH_3: '3Bdr/3Bath',
    EFFICIENCY: 'Efficiency',
    STUDIO: 'Studio'
};
exports.UnitMixModel = UnitMixModel;
//# sourceMappingURL=unit-mix.model.js.map